import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const WCtx = createContext(null);
export const useWishlist = () => useContext(WCtx);

export function WishlistProvider({ children }) {
  const { user } = useAuth();
  const [items, setItems] = useState(() => JSON.parse(localStorage.getItem("nl_wish") || "[]"));
  const prevUserRef = React.useRef(user);

  useEffect(() => { localStorage.setItem("nl_wish", JSON.stringify(items)); }, [items]);

  useEffect(() => {
    const prev = prevUserRef.current;
    prevUserRef.current = user;
    // Logout: user became null → clear wishlist state immediately
    if (prev && !user) {
      setItems([]);
      localStorage.removeItem("nl_wish");
      return;
    }
    if (!user) return;
    // Login: merge guest wishlist into server, then sync
    const guest = JSON.parse(localStorage.getItem("nl_wish") || "[]");
    (async () => {
      try {
        const { data } = await api.get("/wishlist");
        const merged = Array.from(new Set([...(data.items || []), ...guest]));
        for (const pid of guest) {
          if (!(data.items || []).includes(pid)) await api.post("/wishlist/toggle", { product_id: pid });
        }
        setItems(merged);
      } catch { /* ignore */ }
    })();
  }, [user]);

  const toggle = async (pid) => {
    if (user) {
      const { data } = await api.post("/wishlist/toggle", { product_id: pid });
      setItems(data.items);
    } else {
      setItems((p) => p.includes(pid) ? p.filter((x) => x !== pid) : [...p, pid]);
    }
  };
  const has = (pid) => items.includes(pid);
  return <WCtx.Provider value={{ items, toggle, has }}>{children}</WCtx.Provider>;
}
